import React, { useState } from "react";
import { Menu, Icon, Layout } from "antd";
import { Link, withRouter } from "react-router-dom";
import { user_roles } from "./enums";


const SubMenu = Menu.SubMenu;
const { Sider } = Layout;

function SidebarMenu(props) {
  let storagedCollapsed = false
  let storedKeys = ["report", "setting"] 

  if (localStorage.getItem('sideBarCollapsed')) {
    storagedCollapsed = JSON.parse(localStorage.getItem('sideBarCollapsed'))
  }
  storedKeys = localStorage.getItem('openKeys')

  let sideBarCollapsed = storagedCollapsed
  let openKeys = []
  
  if (sideBarCollapsed) {
    openKeys = []
  } else if (storedKeys) {
    openKeys = JSON.parse(storedKeys)
  }
  else {
    openKeys = ["report", "setting"]
  }

  
  const [menuState, setMenuState] = useState({ sideBarCollapsed: sideBarCollapsed, openKeys: openKeys })
  
   function handleOpenKeys(newKeys) {
     if (!menuState.sideBarCollapsed) {
       localStorage.setItem('openKeys', JSON.stringify(newKeys))
     }
     //let newState = { ...menuState, openKeys: newKeys }
    //setOpenKeys(newKeys)
  }

  function handleCollaspe(collapsed, type) {
    //console.log( '--------------handleCollaspe:' + collapsed + ' ' + type)
    localStorage.setItem('sideBarCollapsed', JSON.stringify(collapsed))
    let newState = { ...menuState, sideBarCollapsed: collapsed }
    setMenuState( newState )
  }


  function handleLogoutClick() {
    window.sessionStorage.removeItem("UserName");
    window.location.href = "/";
  }

  function SummaryMenu() {
    return (
      <Menu
        //defaultSelectedKeys={[defaultKey]}
        //defaultOpenKeys={openKeys}
        mode="inline"
        theme="dark"
      //selectedKeys={selectedKey}
      //onOpenChange={handleOpenKeys}
      >
        <Menu.Item key="contrSummary" >
          <Icon type="file-pdf" />
          <span>Contribution Summary</span>
         <Link to="/reports/contrSummary" />
        </Menu.Item>
        <Menu.Item key="logout" onClick={handleLogoutClick}>
          <Icon type="logout" />
          <span>Logout</span>
        </Menu.Item>
      </Menu>)
  }

  function FullMenu() {
    return (
      <Menu
        //defaultSelectedKeys={[defaultKey]}
        defaultOpenKeys={openKeys}
        mode="inline"
        theme="dark"
        //selectedKeys={selectedKey}
        onOpenChange={handleOpenKeys}
      >
        <Menu.Item key="members">
          <Icon type="team" />
          <span>Members</span>
          <Link to="/members" />
        </Menu.Item>
        <Menu.Item key="contribution">
          <Icon type="dollar" />
          <span>Contributions</span>
          <Link to="/contribution" />
        </Menu.Item>

        <SubMenu
          key="report"
          title={
            <span>
              <Icon type="file-pdf" />
              <span>Reports</span>
            </span>
          }
        >
          <Menu.Item key="memberlist">
            Member List
              <Link to="/reports/memberlist" />
          </Menu.Item>
          <Menu.Item key="rebateAdjust">
            Rebate % Adjustment
              <Link to="/reports/rebateAdjust" />
          </Menu.Item>
          <Menu.Item key="contrSummary">
            Contribution Summary
              <Link to="/reports/contrSummary" />
          </Menu.Item>
          <Menu.Item key="contrDetails">
            Contribution Details
              <Link to="/reports/contrDetails" />
          </Menu.Item>
          <Menu.Item key="receipts">
            Receipts
              <Link to="/reports/receipts" />
          </Menu.Item>
        </SubMenu>

        <SubMenu
          key="setting"
          title={
            <span>
              <Icon type="setting" />
              <span>MyAccount</span>
            </span>
          }
        >
          <Menu.Item key="organization">
            Organisation Details
              <Link to="/organization" />
          </Menu.Item>
          <Menu.Item key="account">
            Account Maintenance
              <Link to="/account" />
          </Menu.Item>
            <Menu.Item key="users">
              User Managment
              <Link to="/users" />
            </Menu.Item> 
          <Menu.Item key="funds">
            Predefined Funds
              <Link to="/funds" />
          </Menu.Item>
        </SubMenu>
        <Menu.Item key="logout" onClick={handleLogoutClick}>
          <Icon type="logout" />
          <span>Logout</span>
        </Menu.Item>

      </Menu>
      )
  }

  return (
    <Sider collapsible width='220' collapsedWidth='60' style={{ minHeight: '100vh' }}
      collapsed={sideBarCollapsed}
      // defaultCollapsed={sideBarCollapsed} 
      onCollapse={handleCollaspe}
    >
      <div className="logo" ><Link to="/"><Icon style={{ fontSize: '24px' }} type="global" /> </Link></div>
      {props.userRole === user_roles.SUMMARY_ONLY ? <SummaryMenu/> :  <FullMenu /> }

    </Sider>
  );
}


export default withRouter(SidebarMenu);
